import { render } from "./changePwd.vue?vue&type=template&id=e118de56&scoped=true"
import script from "./changePwd.vue?vue&type=script&lang=js"
export * from "./changePwd.vue?vue&type=script&lang=js"

import "./changePwd.vue?vue&type=style&index=0&id=e118de56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e118de56"

export default script